import { RoleAccessResponse } from '../models/RoleAccessResponse';
import { atom } from 'recoil';
//TODO need to be review for check sync loading
export const roleAccessState = atom<RoleAccessResponse | undefined>({
  key: 'roleAccessState',
  default: undefined,
});
